<template>
  <div class="header">
    <div class="header_top">
      <div class="top_title"></div>
      <div><a-button type="primary" size="large" @click="wayLoginOut">退出登录</a-button></div>
    </div>
  </div>
</template>

<script setup name='header'>
import { useRouter } from 'vue-router';

const router = useRouter()

// 退出登录
const wayLoginOut = ()=>{
  localStorage.removeItem('viUserDetailBaiXiong')
  router.replace({
    name:'login'
  }) 
}
</script>

<style lang='scss' scoped>
.header{
  .header_top{
    display: flex;
    align-items: center;
    justify-content: space-between;
    .top_title{
      font-size: 20px;
      font-weight: 500;
    }
  }
}
</style>